import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface ISelectValue {
  value: string;
  label: string;
}
@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements OnInit {
  @Input() values: ISelectValue[] = [];
  @Output() changeSelected: EventEmitter<string> = new EventEmitter();
  optionSelected: string;
  constructor() {}

  ngOnInit(): void {
    this.optionSelected = this.values[0]?.value || '';
  }

  changeValue(option: string) {
    this.optionSelected = option;
    this.changeSelected.emit(option);
  }
}
